import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_BALANCE_HISTORIES_LIST_API_ID =
  'FETCH_STOCK_BALANCE_HISTORIES_LIST_API_ID';

const apiCall = createApiCall(
  FETCH_STOCK_BALANCE_HISTORIES_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/stock-balance-histories`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
